import AsyncStorage from 'shared/asyncStorage';
import ApiUtils from 'shared/ApiUtils'
import DataPreprocessing from 'shared/DataPreprocessing'
import { ACCESS_TOKEN } from 'store/modules/auth/actions'
import * as d3 from "d3";

export const FETCH_HOUSING_DATA_START = 'FETCH_HOUSING_DATA_START'
export const FETCH_HOUSING_DATA_SUCCESS = 'FETCH_HOUSING_DATA_SUCCESS'
export const FETCH_HOUSING_DATA_FAIL = 'FETCH_HOUSING_DATA_FAIL'

export const FETCH_PIPELINE_DATA_START = 'FETCH_PIPELINE_DATA_START'
export const FETCH_PIPELINE_DATA_SUCCESS = 'FETCH_PIPELINE_DATA_SUCCESS'
export const FETCH_PIPELINE_DATA_FAIL = 'FETCH_PIPELINE_DATA_FAIL'

export const FETCH_SNAPSHOT_START = 'FETCH_SNAPSHOT_START'
export const FETCH_SNAPSHOT_SUCCESS = 'FETCH_SNAPSHOT_SUCCESS'
export const FETCH_SNAPSHOT_FAIL = 'FETCH_SNAPSHOT_FAIL'

export const UPLOAD_FILE_START = 'UPLOAD_FILE_START'
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS'
export const UPLOAD_FILE_FAIL = 'UPLOAD_FILE_FAIL'

export const CLEAR_UPLOAD_ERRORS = 'CLEAR_UPLOAD_ERRORS'

export const FETCH_AGENCY_LIST_START = 'FETCH_AGENCY_LIST_START'
export const FETCH_AGENCY_LIST_SUCCESS = 'FETCH_AGENCY_LIST_SUCCESS'
export const FETCH_AGENCY_LIST_FAIL = 'FETCH_AGENCY_LIST_FAIL'

export const FETCH_HOUSING_NPU_START = 'FETCH_HOUSING_NPU_START'
export const FETCH_HOUSING_NPU_SUCCESS = 'FETCH_HOUSING_NPU_SUCCESS'


export function getHousingDataStart() {
    return { type: FETCH_HOUSING_DATA_START }
}

export function getHousingDataSuccess(data) {
    return { type: FETCH_HOUSING_DATA_SUCCESS, payload: data, receivedAt: Date.now() }
}

export function getHousingDataFail(error) {
    return { type: FETCH_HOUSING_DATA_FAIL, error, receivedAt: Date.now() }
}

export function getPipelineDataStart() {
    return { type: FETCH_PIPELINE_DATA_START }
}

export function getPipelineDataSuccess(data) {
    return { type: FETCH_PIPELINE_DATA_SUCCESS, payload: data, receivedAt: Date.now() }
}

export function getPipelineDataFail(error) {
    return { type: FETCH_PIPELINE_DATA_FAIL, error, receivedAt: Date.now() }
}

export function getSnapshotStart() {
    return { type: FETCH_SNAPSHOT_START }
}

export function getSnapshotSuccess(data) {
    return { type: FETCH_SNAPSHOT_SUCCESS, payload: data, receivedAt: Date.now() }
}

export function getSnapshotFail(error) {
    return { type: FETCH_SNAPSHOT_FAIL, error, receivedAt: Date.now() }
}

export function uploadFileStart() {
    return { type: UPLOAD_FILE_START }
}

export function uploadFileSuccess(data) {
    return { type: UPLOAD_FILE_SUCCESS, payload: data, receivedAt: Date.now() }
}

export function uploadFileFail(error) {
    return { type: UPLOAD_FILE_FAIL, error, receivedAt: Date.now() }
}

export function clearUploadErrors() {
    return { type: CLEAR_UPLOAD_ERRORS, receivedAt: Date.now() };
}

export function getAgencyListStart() {
    return { type: FETCH_AGENCY_LIST_START }
}

export function getAgencyListSuccess(data) {
    return { type: FETCH_AGENCY_LIST_SUCCESS, payload: data, receivedAt: Date.now() }
}

export function getAgencyListFail() {
    return { type: FETCH_AGENCY_LIST_FAIL, receivedAt: Date.now() }
}

export function getHousingNPUDataStart() {
    return { type: FETCH_HOUSING_NPU_START}
}

export function getHousingNPUDataSuccess(data) {
    return { type: FETCH_HOUSING_NPU_SUCCESS, payload: data, receivedAt: Date.now() }
}

export const fetchHousingData = () => dispatch => {
    dispatch(getHousingDataStart())
    // const url = 'https://atl-cspav.herokuapp.com/data';
    // return ApiUtils.get(url)
    //     .then(([response, jsonBody]) => {
    //         if (response.status === 200) {
                // console.log(jsonBody)
    DataPreprocessing.getfile().then(([response, jsonBody]) => {
        var reducedata = jsonBody
        var data = DataPreprocessing.convertToGeoJSON(reducedata)

        var processedData = DataPreprocessing.filterDataBeforeFeedIntoDashboard(data)

        // console.log(processedData)

        dispatch(getHousingDataSuccess(processedData))
    // } else {
    //     dispatch(getHousingDataFail(jsonBody.message))
    // }
    })
    .catch((err) => {
        dispatch(getHousingDataFail(err.message));
    })
}

export const fetchPipelineData = () => dispatch => {

    dispatch(getPipelineDataStart())

    //read csv
    d3.csv(require('assets/data/csvs/House_ATL_Pipeline_Dummy_Data.csv')).then(function(csvFile) {
        // console.log(csvFile);
        d3.csv(require('assets/data/csvs/TableManifest.csv')).then(function(formatFile) {

            var formatDecimal = d3.format(",.5f");

            csvFile.forEach(function(d){ 
                formatFile.forEach(function(f){ 
                if(f["Type"]==="integer"){
                    d[f["Variable"]] = +d[f["Variable"]]; 
                }

                if (f["Type"]==="float, 5"){
                    d[f["Variable"]] = formatDecimal(d[f["Variable"]]); 
                }
                
                })
            });

            const newCsvFile = csvFile.map(function(num){
                var newdict = {}
                // replace dot to underscore for all fieldnames
                for (var [key, value] of Object.entries(num)) {
                    if (key.indexOf('.') !== -1){
                        // console.log(key.replace(/\./g, '_'))
                        newdict[key.replace(/\./g, '_')] = value
                    }else{
                        newdict[key] = value
                    }
                }
                return newdict
            })
    
            // console.log(newCsvFile);
    
            var data = DataPreprocessing.convertToGeoJSONForPipelineData(newCsvFile)
    
            // console.log(data);
            dispatch(getPipelineDataSuccess(data))
        })
    })

}

export const fetchSnapshotData =  () => dispatch => {
    dispatch(getSnapshotStart())
    // const url = 'https://atl-cspav.herokuapp.com/snapshot';
    // return ApiUtils.getAuth(url, token)
    //             .then(([response, jsonBody]) => {
    //                 if (response.status === 200) {
                        // generate the json from the raw data
                       
                        
    DataPreprocessing.getfile().then(([response, jsonBody]) => {

        // console.log(jsonBody)
        var src =  jsonBody


        var fundingdict = {}
        var riskdict = {}
        riskdict["Expiring within 1 year"] = 0
        riskdict["Expiring within 3 years"]  = 0
        riskdict["Expiring within 5 years"] = 0
        riskdict["Expiring within 6 months"] = 0


        var stewarding = {}
        var cnt = 0
        // console.log(src)
        src.forEach(function(prop,indexProp){
            var totalUnitsSubForProp = 0
            prop["subsidies"].forEach(function(subs,indexSubs){
                //console.log(subs["UnitsSub"])
                if (subs["UnitsSub"] == null){
                
                    subs["UnitsSub"] = 0
                }

                if (subs["UnitsSub"] > totalUnitsSubForProp){
                    totalUnitsSubForProp = subs["UnitsSub"]
                }

                // cnt += subs["UnitsSub"]

                //console.log(cnt)

                if(subs["Stewarding"] in stewarding){
                    stewarding[subs["Stewarding"]] = stewarding[subs["Stewarding"]] + subs["UnitsSub"]
                }else{
                    stewarding[subs["Stewarding"]] = subs["UnitsSub"]
                }
                
                subs["Funding"].forEach(function(funds,indexFunds){
                    if(funds in fundingdict){
                        fundingdict[funds] = fundingdict[funds] + subs["UnitsSub"]
                    }else{
                        fundingdict[funds] = subs["UnitsSub"]
                    }
                })
                if (subs["RiskUnits"] === "n/a"){
                    
                    return;
                }else{
                    
                    riskdict[subs["RiskUnits"]] = riskdict[subs["RiskUnits"]] + subs["UnitsSub"]
                }

                

            })  

            cnt += totalUnitsSubForProp
        })

            
        var res = {}
        res["funding"] = fundingdict
        res["risk"] = riskdict
        res["stewarding"] = stewarding
        res["total"] = cnt



        // console.log(res)
        dispatch(getSnapshotSuccess(res))

            // original call part from backend
            // console.log(jsonBody)
            // dispatch(getSnapshotSuccess(jsonBody))
    //     } else {
    //         dispatch(getSnapshotFail(jsonBody.message))
    //     }
    })
    .catch((err) => {
        dispatch(getSnapshotFail(err.message));
    })
    
}

export const uploadFile = (file) => dispatch => {
    dispatch(uploadFileStart())
    const url = 'https://houseatl.cloud.rnoc.gatech.edu/rest/rpc/file_upload';
    return AsyncStorage.getItem(ACCESS_TOKEN)
        .then(token => {
            if (token) {
                ApiUtils.postFile(url, token, file)
                    .then(([response, jsonBody]) => {
                        if (response.status === 200) {
                            dispatch(uploadFileSuccess(jsonBody))
                        } else {
                            dispatch(uploadFileFail(jsonBody.message))
                        }
                    })
                    .catch((err) => {
                        console.log('Error:', err)
                    })
            } else {
                console.log('Cannot upload, user does not have token.')
            }
        })
}

export const fetchAgencyList = () => dispatch => {
    dispatch(getAgencyListStart())
    const url = 'https://house-atl-api-dev.herokuapp.com/rest/agencies?';
    return AsyncStorage.getItem(ACCESS_TOKEN)
        .then(token => {
            if (token) {
                ApiUtils.getAuth(url, token)
                    .then(([response, jsonBody]) => {
                        if (response.status === 200) {
                            const result = jsonBody.map(({ id, name }) => ({ id, name, }))
                            dispatch(getAgencyListSuccess(result))
                        } else {
                            dispatch(getAgencyListFail())
                        }
                    })
                    .catch((err) => {
                        console.log('Error:', err)
                    })
            } else {
                console.log('Cannot fetch agencies, user does not have token.')
            }
        })
}

export const fetchHousingNPUData = (geojson) => dispatch => {
  
    // const url = 'https://atl-cspav.herokuapp.com/layers';
    // return ApiUtils.post(url, geojson)
    //             .then(([response, jsonBody]) => {
                
    //                 if (response.status === 200) {
                  
    //                     dispatch(getHousingNPUDataSuccess(jsonBody))
    //                 } else {
    //                     console.log(jsonBody.message)
    //                 }
    //             })
    //             .catch((err) => {
    //                 console.log('Error:', err)
    //             })
    //console.log(geojson)
    dispatch(getHousingNPUDataStart())
    var npuData = require('assets/data/geographies/ATL_NPUs.json')
    var tractData = require('assets/data/geographies/ATL_Tracts.json')
    var tadData = require('assets/data/geographies/ATL_Tax_Allocation_District.json')
    var councilData = require('assets/data/geographies/ATL_City_Council_Districtswgs.json')
    var nsaData = require('assets/data/geographies/ATL_Neighborhood_Statistical_Areas.json')
    var schoolData = require('assets/data/geographies/ATL_SchoolZones.json')
    var highSchoolData = require('assets/data/geographies/ATL_HighSchoolZones.json')
    
    //update res
    var res = {}
    res["npu"] = DataPreprocessing.addHousingSummarytoGeoData(npuData,geojson)
    res["tract"] = DataPreprocessing.addHousingSummarytoGeoData(tractData,geojson)
    res["school"] = DataPreprocessing.addHousingSummarytoGeoData(schoolData,geojson)
    res["neighborhood"] = DataPreprocessing.addHousingSummarytoGeoData(nsaData,geojson)
    res["council"] = DataPreprocessing.addHousingSummarytoGeoData(councilData,geojson)
    res["tax"] = DataPreprocessing.addHousingSummarytoGeoData(tadData,geojson)
    res["highSchool"] = DataPreprocessing.addHousingSummarytoGeoData(highSchoolData,geojson)
    
    //console.log(res)
    // create a copy of res otherwise it won't work
    // get the idea from https://stackoverflow.com/questions/50739021/redux-reducer-prevstate-already-set-up-to-newstate
    dispatch(getHousingNPUDataSuccess(JSON.parse(JSON.stringify(res))))

    //console.log(npuData)
}











